export const EXTRACTION_PROPERTIES_CONSTANTS = [
  {
    propertyName: "Email Summary",
    description: "Summarize email text in one-two sentences"
  },
  {
    propertyName: "Keywords",
    description: "Identify and extract key terms indicative of the email's subject, like product names or industry-specific terms."
  },
  {
    propertyName: "Meeting Dates",
    description: "Extract dates and times mentioned in relation to meetings, appointments, or events."
  },
  {
    propertyName: "Order Tracking Number",
    description: "Capture sequences identified as tracking numbers in transactional emails."
  },
  {
    propertyName: "Subscription Information",
    description: "Extract details about subscriptions, including names, dates, and renewal terms."
  },
  {
    propertyName: "Action Items",
    description: "Identify and extract tasks or actions required from the email recipient."
  },
  {
    propertyName: "Deadlines",
    description: "Extract specific dates or times indicating a deadline or due date."
  }
];
